﻿package com.mgacreative.hotelru.feature.admin.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.core.network.SupabaseNetworkClient
import io.github.jan.supabase.postgrest.postgrest
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import com.mgacreative.hotelru.core.tenant.TenantSession
import kotlinx.serialization.Serializable
import kotlinx.serialization.SerialName

@Serializable
data class TenantProfile(
    val id: String = "",
    val name: String = "",
    val phone: String? = null,
    val email: String? = null,
    val address: String? = null,
    val social_media: String? = null,
    @SerialName("company_title") val companyTitle: String? = null,
    @SerialName("tax_office") val taxOffice: String? = null,
    @SerialName("tax_number") val taxNumber: String? = null,
    @SerialName("authorized_person") val authorizedPerson: String? = null
)

class AdminViewModel(
    private val supabaseClient: SupabaseNetworkClient,
    private val tenantSession: TenantSession
) : ViewModel() {
    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading.asStateFlow()

    private val _profile = MutableStateFlow<TenantProfile?>(null)
    val profile: StateFlow<TenantProfile?> = _profile.asStateFlow()

    fun loadDashboardData() {
        viewModelScope.launch {
            _isLoading.value = true
            try {
                val tenantId = tenantSession.sessionState.value.tenantId
                if (tenantId != null) {
                    val data = supabaseClient.client.postgrest["tenants"]
                        .select { filter { eq("id", tenantId) } }
                        .decodeSingleOrNull<TenantProfile>()
                    _profile.value = data
                }
            } catch (e: Exception) {
                // handle error
            } finally {
                _isLoading.value = false
            }
        }
    }
    fun updateProfile(
        name: String, 
        phone: String, 
        email: String, 
        address: String, 
        socialMedia: String,
        companyTitle: String = "",
        taxOffice: String = "",
        taxNumber: String = "",
        authorizedPerson: String = ""
    ) {
        viewModelScope.launch {
            _isLoading.value = true
            try {
                val tenantId = tenantSession.sessionState.value.tenantId
                if (tenantId != null) {
                    val updateData = TenantProfile(
                        id = tenantId,
                        name = name,
                        phone = phone,
                        email = email,
                        address = address,
                        social_media = socialMedia,
                        companyTitle = companyTitle,
                        taxOffice = taxOffice,
                        taxNumber = taxNumber,
                        authorizedPerson = authorizedPerson
                    )
                    supabaseClient.client.postgrest["tenants"]
                        .update(updateData) {
                            filter { eq("id", tenantId) }
                        }
                    _profile.value = updateData
                }
            } catch (e: Exception) {
                // handle error
            } finally {
                _isLoading.value = false
            }
        }
    }
}

